export function toNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
}

export function compactNumber(value) {
  const number = toNumber(value);
  if (number >= 1000000) return `${(number / 1000000).toFixed(number >= 10000000 ? 0 : 1)}M`;
  if (number >= 1000) return `${(number / 1000).toFixed(number >= 10000 ? 0 : 1)}k`;
  return String(number);
}

function firstNumber(...values) {
  for (const value of values) {
    if (value !== undefined && value !== null) {
      return toNumber(value);
    }
  }

  return 0;
}

function sumWhenPresent(project, keys) {
  const hasAnyKey = keys.some(key => project[key] !== undefined && project[key] !== null);
  if (!hasAnyKey) return undefined;
  return keys.reduce((total, key) => total + toNumber(project[key]), 0);
}

function sumFromItems(items, keys) {
  if (!Array.isArray(items) || !items.length) return undefined;
  return items.reduce((total, item) => {
    const value = firstNumber(...keys.map(key => item?.[key]));
    return total + value;
  }, 0);
}

export function projectMetrics(project = {}, options = {}) {
  const includeViews = options.includeViews !== false;
  const views = firstNumber(project.views_capitulos, project.views, project.views_count);
  const likes = firstNumber(
    project.likes_total,
    project.likes_count_total,
    sumWhenPresent(project, ["likes_obra_mes", "likes_capitulos_mes"]),
    sumWhenPresent(project, ["likes_obra", "likes_capitulos"]),
    project.likes_count,
    project.like_count,
    project.likes,
    sumFromItems(project.titles, ["likes_count", "likes", "like_count"])
  );
  const comments = firstNumber(
    project.comments_total,
    sumWhenPresent(project, ["comentarios_obra_mes", "comentarios_capitulos_mes"]),
    sumWhenPresent(project, ["comentarios_obra", "comentarios_capitulos"]),
    sumFromItems(project.titles, ["comments", "comments_count", "comment_count"]),
    project.comments_count,
    project.comments,
    project.comment_count
  );
  const metrics = [];

  if (includeViews) {
    metrics.push({ key: "views", label: "Views", icon: "mdi-eye", value: views });
  }

  metrics.push(
    { key: "likes", label: "Curtidas", icon: "mdi-thumb-up", value: likes },
    { key: "comments", label: "Comentarios", icon: "mdi-message-text", value: comments }
  );

  return metrics;
}
